@if (
  partner.is_widget_banner_hint_enabled &&
  partner.widget_banner_hint_text !== null &&
  isWhitelabel()
) {
  <div
    [class]="'mt-3 cbw-widget-hint alert alert-' + partner.widget_banner_hint_color"
    [innerHTML]="partner.widget_banner_hint_text | trustHtml"
    role="alert"
    aria-live="polite"
  ></div>
}

<!--
  storeSelectorVisible is the union of the three branch conditions below, so the region is never
  rendered empty and the empty-state message can key off whether a selector is really on screen.
-->
@if (storeSelectorVisible) {
  <div class="form-group mt-4" role="region" aria-label="Store selection">
    @if (storeSelectorIsPostcodeSearch) {
      <div class="row mt-3">
        <div class="col-lg-12">
          <app-cw-title class="cbw-select-store-title" id="store-selection-title" compTitle="{{ storeLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}" />
        </div>
        <div class="col-lg-12 mt-2">
          <ng-select
            #postCodeSelect
            id="store-postcode-select"
            [loading]="isStoreLoading"
            [required]="true"
            [(ngModel)]="appointmentState.selectedStorePostcodeMappingId"
            #selectStore="ngModel"
            bindLabel="name"
            bindValue="postcode_sore_id"
            [items]="stores"
            [typeahead]="searchStores"
            [searchable]="true"
            typeToSearchText="{{ widgetStoreSelectionHint | translation: templateContent.TEMPLATE_CONTENT: lang }}"
            (change)="onStoreSelected($event)"
            notFoundText="{{ 'store_not_found' | translate }}"
            aria-labelledby="search_store_by_postcode_placeholder"
            [attr.aria-describedby]="'store-selection-help'"
            role="combobox"
            aria-haspopup="listbox"
            [attr.aria-expanded]="!!isStoreLoading"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div class="store-name">
                @if (partner?.include_city_name_in_postcode_results === 1) {
                  <!--
                    case when wanted to show city name along with postcode and store name in bracket (e.g. EGK partner)
                    5600 Lenzburg (Solothurn)
                  -->
                  {{ item?.postcode_details?.postcode }} {{ item?.postcode_details?.city }}
                  @if (item?.city) {
                    ({{ item.city }})
                  }
                } @else {
                  <!-- case when wanted to show only store name (e.g. BMS Sanitas) -->
                  {{ item | translation: 'name': lang }}
                }

                @if (item.distance && partner.show_distance_in_stores === 1) {
                  <!-- case when wanted to show near by store with distance calculation based on google map (e.g. BMS partner) -->
                  <span>
                    ({{ 'appointments.step1.distance_from_store' | translate: { distance: (item.distance | number:'1.0-0') } }})
                  </span>
                }
              </div>
            </ng-template>

            <ng-template ng-label-tmp let-item="item">
              <div class="store-name">
                @if (partner?.include_city_name_in_postcode_results === 1) {
                  {{ item?.postcode_details?.postcode }} {{ item.postcode_details?.city }}
                  @if (item?.city) {
                    ({{ item.city }})
                  }
                } @else {
                  {{ item | translation: 'name': lang }}
                }

                @if (item.distance && partner.show_distance_in_stores === 1) {
                  <span>
                    ({{ 'appointments.step1.distance_from_store' | translate: { distance: (item.distance | number:'1.0-0') } }})
                  </span>
                }
              </div>
            </ng-template>

            <ng-template ng-loadingspinner-tmp>
              <div role="status" aria-live="polite" attr.aria-label="{{ 'common.loading' | translate }}" class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </ng-template>
          </ng-select>

          <div id="search_store_by_postcode_placeholder" role="complementary">
            <small
              class="calio-text-muted"
              [innerHTML]="widgetStoreSelectionHint | translation: templateContent.TEMPLATE_CONTENT: lang | trustHtml: 'html'"
            ></small>
          </div>
        </div>
      </div>
    } @else if (storeSelectorIsCardList) {
      <div class="store-container row" role="radiogroup" [attr.aria-labelledby]="'store-selection-title'">
        <div class="col-lg-12">
          <app-cw-title class="cbw-select-store-title" id="store-selection-title" compTitle="{{ storeLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}" />
        </div>

        @for (store of stores; track store.id; let odd = $odd) {
          <app-cw-card
            class="col-lg-6 col-md-6 col-sm-6 mt-3"
            [ngClass]="{ 'odd-store': odd }"
            [cardClass]="'cbw-store-select-card'"
            role="listitem"
          >
            <div
              body
              class="d-flex align-items-center justify-content-between store-body"
              (click)="onStoreSelected(store)"
              (keydown.enter)="onStoreSelected(store)"
              (keydown.space)="onStoreSelected(store); $event.preventDefault()"
              role="button"
              tabindex="0"
              [attr.aria-checked]="store.id === appointmentState.store"
              [attr.aria-label]="(store | translation: 'name': lang) + ' ' + 'Select store'"
            >
              <div>
                <div class="store-name">{{ store | translation: 'name': lang }}</div>
                @if (store.is_online === 0) {
                  <div class="store-address text-muted whitespace-pre-line" aria-label="Store address">
                    @let addressInput = {
                      street: store?.street,
                      zip: store?.zip,
                      city: store?.city,
                      country: store?.country | translation: 'name': lang,
                      country_code: store?.country?.identifier
                    };
                    {{ addressInput | addressFormat: 'single' }}
                  </div>
                }
              </div>

              <div>
                <app-cw-radio-tick-button
                  [color]="store.id === appointmentState.store ? widgetColorConf.widget_header_active_color : ''"
                  [checked]="store.id === appointmentState.store"
                  aria-hidden="true"
                />
              </div>
            </div>
          </app-cw-card>
        }
      </div>
    } @else if (storeSelectorIsDropdown) {
      <div class="row mt-3">
        <div class="col-lg-12">
          <app-cw-title class="cbw-select-store-title" id="store-selection-title" compTitle="{{ storeLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}" />
        </div>
        <div class="col-lg-12 mt-2">
          <ng-select
            id="store-dropdown-select"
            [required]="true"
            [(ngModel)]="appointmentState.store"
            #selectStore="ngModel"
            bindLabel="name"
            bindValue="id"
            [items]="stores"
            [notFoundText]="'store_not_found' | translate"
            (change)="onStoreSelected($event)"
            aria-labelledby="store-selection-title"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <div>
                @if (item?.is_multi_language === 1) {
                  <div class="store-name">
                    {{ item | translation: 'name': lang }}
                  </div>
                } @else {
                  <div class="store-name">
                    {{ item.name }}
                  </div>
                }
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div>
                @if (item?.is_multi_language === 1) {
                  <div class="store-name">
                    {{ item | translation: 'name': lang }}
                  </div>
                } @else {
                  <div class="store-name">
                    {{ item.name }}
                  </div>
                }
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    }
  </div>
}

@if ((partner.enable_store_postcode_feature === 1 && appointmentState.store) || partner.enable_store_postcode_feature !== 1 || hasNoStoresAtAll) {
  @if (appointmentServicesByCat?.length > 0) {
    <app-appointment-services
      [widgetTemplates]="widgetTemplates"
      [appointmentServicesByCat]="appointmentServicesByCat"
      [stores]="stores"
      [lang]="lang"
      [(appointmentState)]="appointmentState"
      [partner]="partner"
      [conferenceState]="conferenceState"
      (serviceChangeEvent)="serviceChangeEvent.emit($event)"
      (disabledServiceTabEvent)="disabledServiceTabEvent.emit($event)"
      (shortcutNavigateToEvent)="shortcutNavigateTo()"
      (navigateToEvent)="navigateTo($event.page, $event.isFirstTime)"
    />
  } @else if (isServicesLoading || (appointmentState.store && !servicesResolved)) {
    <div class="services-skeleton mt-4" role="status" aria-live="polite" attr.aria-label="{{ 'common.loading' | translate }}">
      <div class="skeleton-animation">
        <div class="bar skeleton-title-bar"></div>
      </div>

      @if (partner.enable_services_search === 1) {
        <div class="skeleton-animation mt-3">
          <div class="bar skeleton-search-bar"></div>
        </div>
      }

      @for (item of [1, 2]; track item) {
        <div class="skeleton-accordion-item skeleton-expanded-panel">
          <div class="d-flex align-items-center justify-content-start">
            <div class="skeleton-animation">
              <div class="bar skeleton-category-name"></div>
            </div>
          </div>
  
          @for (row of [1, 2, 3]; track row) {
            <div class="skeleton-service-row">
              <div class="d-flex align-items-start">
                <div class="skeleton-animation skeleton-checkbox-col">
                  <div class="bar skeleton-checkbox"></div>
                </div>
                <div class="skeleton-service-detail">
                  <div class="skeleton-animation">
                    <div class="bar skeleton-service-name" [class.skeleton-name-short]="row === 2"></div>
                  </div>
                  <div class="skeleton-animation mt-1">
                    <div class="bar skeleton-service-desc" [class.skeleton-desc-long]="row === 1"></div>
                  </div>
                </div>
                <div class="skeleton-animation skeleton-duration-col">
                  <div class="bar skeleton-duration"></div>
                </div>
                <div class="skeleton-animation skeleton-price-col">
                  <div class="bar skeleton-price"></div>
                </div>
              </div>
            </div>
          }
        </div>
      }

    </div>
  } @else if (hasNoBookableServices || hasNoStoresAtAll) {
    <!--
      A store is selected and its services have loaded empty. Only reachable once a store is
      actually chosen, so a partner using the store dropdown still gets its selector (and no
      message) while it waits for the visitor to pick one.
    -->
    <!--
      The description ("contact the provider directly") is only right when the visitor has no way
      forward inside the widget. Keyed off whether a selector is actually ON SCREEN, not merely off
      hideStoreSelection — the selector block has no final @else, so a single-store partner can have
      hideStoreSelection false and still see no selector at all.
    -->
    <app-new-alert
      type="warning"
      title="{{ (servicesLoadFailed ? 'error_messages.something_went_wrong' : 'common.booking_unavailable') | translate }}"
      subTitle="{{ (!servicesLoadFailed && !storeSelectorVisible) ? ('common.booking_unavailable_description' | translate) : '' }}"
      customClass="mt-3 mb-3"
    />
  }
}
@if (showConferenceError) {
  <app-new-alert subTitle="{{ 'common.conference_invalid_configurations' | translate }}" type="danger" customClass="mx-3" role="alert" aria-live="assertive" />
}

@if (showStepValidationError() && appointmentState.services.length < 1) {
  <div
    id="cbw-service-validation-error"
    class="cbw-global-step-error cbw-service-step-error"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="cbw-step-error-text">
      {{ stepErrorTemplate ? (stepErrorTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) : ('alert_messages.next_step_error_service' | translate) }}
    </div>
  </div>
}

<div class="wizard-footer clearfix" role="navigation" aria-label="Navigation">
  <div class="row margin-x-0">
    <div class="col-4 d-flex align-items-center justify-content-start">
      @if (!isWhitelabel()) {
        <div class="d-md-none">
          <img
            alt="Logo"
            src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
            width="100"
            role="img"
            aria-label="Logo"
          >
        </div>
      }
    </div>
    <div class="col-4 d-flex align-items-center justify-content-center">
      @if (!isWhitelabel()) {
        <div class="d-none d-md-block">
          <img
            alt="Logo"
            src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
            width="100"
          >
        </div>
      }
    </div>
    <div class="col-4 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
      @if (enteredAppointmentFromTour) {
        <calenso-button
          type="secondary"
          id="cbw-prev-button-tour"
          class="me-2"
          text="{{ previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
          placement="left"
          [widgetColorConf]="widgetColorConf"
          (clickEvent)="backToTourEvent.emit({ resetSelection: false })"
          aria-label="Back to tour selection"
        />
      } @else if (partner?.is_customer_profiles_feature_enabled === 1 && partner?.customer_profiles?.length > 1) {
        <calenso-button
          type="secondary"
          id="cbw-prev-button"
          class="me-2"
          text="{{ previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
          placement="left"
          [widgetColorConf]="widgetColorConf"
          (clickEvent)="navigateTo(appointmentConstant.CUSTOMER_TYPE)"
          aria-label="Previous step"
        />
      }

      @if (!hasNoBookableServices && !hasNoStoresAtAll) {
        <calenso-button
          type="primary"
          id="cbw-next-button"
          text="{{ nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
          placement="right"
          [disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : appointmentState.services.length < 1"
          [widgetColorConf]="widgetColorConf"
          (clickEvent)="onNextButtonClick()"
          aria-label="Next step"
          [attr.aria-describedby]="showStepValidationError() && appointmentState.services.length < 1 ? 'cbw-service-validation-error' : null"
        />
      }
    </div>
  </div>
</div>
